import styled from 'styled-components';

const AppDockFooter = styled.div`
  padding-top: ${props => props.theme.spacing(1)}px;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  background-color: ${props => props.theme.palette.background.dock};
`;

export default AppDockFooter;
